import { gql } from '@apollo/client';

/**
 * Save the authenticated user's own weekly recurring schedule.
 */
export const SET_MY_WEEKLY_SCHEDULE = gql`
  mutation SetMyWeeklySchedule($input: SetMyWeeklyScheduleInput!) {
    setMyWeeklySchedule(input: $input)
  }
`;

/**
 * Create a time-off entry for the authenticated user.
 */
export const CREATE_MY_VACATION = gql`
  mutation CreateMyVacation($input: MyVacationInput!) {
    createMyVacation(input: $input) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      reviewedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * Update a time-off entry owned by the authenticated user.
 */
export const UPDATE_MY_VACATION = gql`
  mutation UpdateMyVacation($id: String!, $input: MyVacationInput!) {
    updateMyVacation(id: $id, input: $input) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      reviewedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * Delete a time-off entry owned by the authenticated user.
 */
export const DELETE_MY_VACATION = gql`
  mutation DeleteMyVacation($id: String!) {
    deleteMyVacation(id: $id)
  }
`;

/**
 * Set or clear the authenticated user's coverage / back-up contact.
 * Pass null to clear an existing selection.
 */
export const SET_MY_COVERAGE = gql`
  mutation SetMyCoverage($coverageUserId: Int) {
    setMyCoverage(coverageUserId: $coverageUserId)
  }
`;

/**
 * Upsert a per-date schedule override for the authenticated user.
 * Saving the same date again replaces the previous override.
 */
export const SET_MY_SCHEDULE_OVERRIDE = gql`
  mutation SetMyScheduleOverride($input: ScheduleOverrideInput!) {
    setMyScheduleOverride(input: $input) {
      id
      date
      isWorking
      isRemote
      notes
    }
  }
`;

/**
 * Remove a per-date schedule override so the date falls back to the
 * recurring weekly pattern.
 */
export const CLEAR_MY_SCHEDULE_OVERRIDE = gql`
  mutation ClearMyScheduleOverride($date: Timestamp!) {
    clearMyScheduleOverride(date: $date)
  }
`;
